// --------------页面基础数据---------------
// 更新加载状态
export const UPDATE_LOADING = 'UPDATE_LOADING'
// 更新页面加载动画方向
export const UPDATE_DIRECTION = 'UPDATE_DIRECTION'
// 更新页面后退键地址
export const UPDATE_BACK_PATH = 'UPDATE_BACK_PATH'

// 更新页面来自哪里
export const UPDATE_PAGE_FROM = 'UPDATE_PAGE_FROM'
// 更新页面的高度，ios 微信中会存在出现返回菜单，导致高度动态变化
export const UPDATE_WIN_HEIGHT = 'UPDATE_WIN_HEIGHT'

// 更新是否触发了收藏更新,首页重新获取收藏列表
export const UPDATE_IS_TRIGGER_COLLECT = 'UPDATE_IS_TRIGGER_COLLECT'

// 更新是否触发更新搜索列表
export const UPDATE_IS_TRIGGER_SEARCH = 'UPDATE_IS_TRIGGER_SEARCH'

// 更新全局缓存变量
export const UPDATE_COMMON_CACHE_VAL = 'UPDATE_COMMON_CACHE_VAL'

// --------------用户基本信息---------------
// 更新用户ID
export const UPDATE_USER_ID = 'UPDATE_USER_ID'
// 更新用户手机号码
export const UPDATE_USER_PHONE = 'UPDATE_USER_PHONE'
// 更新用户头像
export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR'
// 设置用户token (app only)
export const SET_USER_TOKEN = 'SET_USER_TOKEN'
// 更新用户昵称
export const UPDATE_USER_NICKNAME = 'UPDATE_USER_NICKNAME'
// 更新用户基础信息
export const UPDATE_USER_BASE_INFO = 'UPDATE_USER_BASE_INFO'

// --------------定位，城市，上下班点---------------
// 更新当前城市
export const UPDATE_CURRENT_CITY = 'UPDATE_CURRENT_CITY'
export const UPDATE_LOCATION_CITY = 'UPDATE_LOCATION_CITY'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const UPDATE_LOCATION_ADDRESS = 'UPDATE_LOCATION_ADDRESS'
export const UPDATE_HOT_CITY_LIST = 'UPDATE_HOT_CITY_LIST'
export const UPDATE_OPEN_CITY_LIST = 'UPDATE_OPEN_CITY_LIST'
export const UPDATE_CURRENT_LOCATION = 'UPDATE_CURRENT_LOCATION'
export const UPDATE_HISTORY_ADDRESS = 'UPDATE_HISTORY_ADDRESS'
export const UPDATE_LOCATION_TIPS = 'UPDATE_LOCATION_TIPS'
// 是否已经加载过城市
export const UPDATE_IS_LOADED_LOCATION = 'UPDATE_IS_LOADED_LOCATION'
// 进入页面的href
export const UPDATE_ENTRY_HREF = 'UPDATE_ENTRY_HREF'

// --------------基础配置---------------
export const SET_ENTERPRISE_ID = 'SET_ENTERPRISE_ID'
export const UPDATE_HOME_PAGE_NAV = 'UPDATE_HOME_PAGE_NAV'
export const UPDATE_CURRENT_HOME_PAGE_NAV_ID = 'UPDATE_CURRENT_HOME_PAGE_NAV_ID'
export const UPDATE_CURRENT_HOME_PAGE_NAV_INDEX = 'UPDATE_CURRENT_HOME_PAGE_NAV_INDEX'
export const UPDATE_CONFIG_COMPANY_ADDRESS = 'UPDATE_CONFIG_COMPANY_ADDRESS'

export const UPDATE_NEW_MESSAGE = 'UPDATE_NEW_MESSAGE'
// 缓存华为app 传过来的 定位参数
export const UPDATE_LINK_PARAM_CACHE = 'UPDATE_LINK_PARAM_CACHE'
// 缓存选择地址
export const UPDATE_CHECK_ADDRESS = 'UPDATE_CHECK_ADDRESS'
// 缓存选择线路
export const UPDATE_CHECK_LINE = 'UPDATE_CHECK_LINE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js